export const STATUS_WAITING_PAYMENT = "WAITING_PAYMENT";
export const STATUS_PARTIAL_PAYMENT = "PARTIAL_PAYMENT";
export const STATUS_PAIED = "PAIED";
export const STATUS_APPROVED = "APPROVED";
export const PROPERTY_STATUS = [
  STATUS_WAITING_PAYMENT,
  STATUS_PARTIAL_PAYMENT,
  STATUS_PAIED,
  STATUS_APPROVED,
];

export const TYPE_COMMERCIAL = "COMMERCIAL";
export const TYPE_INDUSTRIAL = "INDUSTRIAL";
export const TYPE_VACANT_LAND = "VACANT_LAND";
export const TYPE_RESIDENTIAL = "RESIDENTIAL";
export const PROPERTY_TYPES = [
  TYPE_COMMERCIAL,
  TYPE_INDUSTRIAL,
  TYPE_VACANT_LAND,
  TYPE_RESIDENTIAL,
];
export const ORIGIN_CSS = "CSS";
export const ORIGIN_MUNICIPALITY = "MUNICIPALITY";
export const ORIGIN_CSS_MUNICIPALITY = "CSS & MUNICIPALITY";
export const PROPERTY_ORIGINS = [
  ORIGIN_CSS,
  ORIGIN_MUNICIPALITY,
  ORIGIN_CSS_MUNICIPALITY,
];

export const TAXES_MUNICIPAL = "MUNICIPAL";
export const TAXES_SCHOOL = "SCHOOL";
export const PROPERTY_TAXES = [TAXES_MUNICIPAL, TAXES_SCHOOL];

export const TRANSACTION_TYPE_PAYMENT = "PAYMENT";
export const TRANSACTION_TYPE_REFUND = "REFUND";
export const TRANSACTION_TYPES = [
  TRANSACTION_TYPE_PAYMENT,
  TRANSACTION_TYPE_REFUND,
];
